import { removeCookie } from '../../utils/cookies';
import { isAuthorMode, isWebView } from '../../utils/aem-utils';

import { onGalleyHashChanged, onNewsUCanUseCardChange } from './parsely-tracking-utils';

const dynamicTrackingHashChangeElementArray = ['.j-gallery-item'];

let currentHash;

/**
 * Clear Parsely Cookies, call this funcion onDomContentLoaded()
 */
const clearParselyTrackingCookies = () => {
  if (!isAuthorMode()) {
    removeCookie('_parsely_session', { domain: '.sky.it', path: '/' });
    removeCookie('_parsely_visitor', { domain: '.sky.it', path: '/' });
    removeCookie('_parsely_slot_click', { domain: '.sky.it', path: '/' });
  }
};

/**
 * Parse.ly Track page view
 * @param {string} url URL to be tracked
 * @param {string} urlRef Referring URL
 */
const dynamicTrackPageView = (url, urlRef) => {
  if (window.PARSELY && window.PARSELY.beacon) {
    window.PARSELY.beacon.trackPageView({
      url,
      urlRef,
      js: 1,
    });
  } else {
    console.error('parse.ly not initialized - 1. ensure that config/skysport.it was loaded');
  }
};

/**
 * Dynamic Parse.ly Tracking on Hash changed
 * onHashChanged callback
 * TODO: for future implementation: switch on element type
 * instead of onGalleyHashChanged()
 */
const dynamicTrackingOnHashChanged = () => {
  const nodelist = document.querySelectorAll(dynamicTrackingHashChangeElementArray.toString());
  if (window.PARSELY && nodelist.length > 0) {
    const result = onGalleyHashChanged(currentHash);
    if (result) {
      const { url, urlRef, actualPageHash } = result;
      dynamicTrackPageView(url, urlRef);
      currentHash = actualPageHash;
    }
  }
};

/**
 * Dynamic Parse.ly Tracking on currentNewsUCanUseCard change
 * @param {string} currentCardId current card id
 */
export const dynamicTrackingOnNewsUCanUse = (currentCardId) => {
  if (window.PARSELY) {
    const result = onNewsUCanUseCardChange(currentCardId);
    if (result) {
      const { url, urlRef } = result;
      dynamicTrackPageView(url, urlRef);
    }
  }
};

/**
 * Dynamic Parse.ly Tracking on Hash changed on Photogallery
 */
export const dynamicTrackingOnPhotogallery = () => {
  if (window.PARSELY) {
    const result = onGalleyHashChanged(currentHash);
    if (result) {
      const { url, urlRef, actualPageHash } = result;
      dynamicTrackPageView(url, urlRef);
      currentHash = actualPageHash;
    }
  }
};

/**
 * Dynamic Parse.ly Tracking on change URL in the same page (eg. Homepage in Article/Liveblog)
 */
export const dynamicTrackingOnURLChange = (url, urlRef) => {
  if (window.PARSELY) {
    dynamicTrackPageView(url, urlRef);
  }
};

/**
 * Itinialize Parsely Tracking Service
 */
const initParselyTrackingService = () => {
  if (isAuthorMode() || isWebView()) {
    return;
  }
  window.addEventListener('hashchange', () => dynamicTrackingOnHashChanged());
};

export { initParselyTrackingService, clearParselyTrackingCookies };
